import React from 'react';
import { Box, Typography } from '@mui/material';

const NoAvailableReports = ({ isSmartCards = false }) => {
    return (
      <Box
        role="status"
        aria-live="polite"
        sx={{
          width: '100%',
          height: '14.5rem',
          borderRadius: '1rem',
          display: 'flex',
          gap: '0.5rem',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
          backgroundColor: '#F8F8F8',
          alignSelf: 'stretch',
          textAlign: 'center'
        }}>
        <Typography
          sx={{
            color: 'var(--ctev-black, #000)',
            leadingTrim: 'both',
            textEdge: 'cap',
            fontFamily: 'Noto Sans',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '150%'
          }}
        >
          No available {isSmartCards ? 'smart cards' : 'reports'}.
        </Typography>
      </Box>
    );
};

export default NoAvailableReports;